import apiClient from "../../../service/apiClient";
import { ADMIN_DOCUMENTS_ENDPOINTS } from "../../../app/apiEndpoints";
import { DOCUMENT_ENDPOINTS } from "../../../app/apiEndpoints";

export const getDocumentSummary = () => {
    return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.GET_DOCUMENT_SUMMARY);
}

export const getAdminDocumentTypes = () => {
    return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.GET_ADMIN_DOCUMENT_TYPES);
}

export const getDocumentFamilies = () => {
    return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.GET_DOCUMENT_FAMILIES);
}

export const getEntitiesByFamilyId = (id) => {
    return apiClient.get(`${ADMIN_DOCUMENTS_ENDPOINTS.GET_ENTITY_BY_FAMILY_ID}/${id}`)
}

export const getDocumentRecipients =(id) => {
    return apiClient.get(`${ADMIN_DOCUMENTS_ENDPOINTS.GET_DOCUMENT_RECIPIENTS}/${id}`)
}

export const updateDocumentStatus = (data) => {
    return apiClient.post(ADMIN_DOCUMENTS_ENDPOINTS.UPDATE_DOCUMENT_STATUS,data)
}

export const getEmailTemplates = () => {
    return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.GET_EMAIL_TEMPLATES)
}

export const insertQueuedEmail = (docids, templateids, userid, doctypeid, queueit) => {
    return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.INSERT_QUEUED_EMAILS,{
        params: {
            docIds:docids,
            templateId:templateids,
            userId:userid,
            documentTypeId:doctypeid,
            queueIt:queueit
        }
    })
}

export const getDocumentByDocumentId = (documentId, isRejected = false, userId = 0, appRoleId = 0) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_DOCUMENT_BLOB_BY_DOCUMENT_ID, {
    params: { documentId, isRejected, userId, appRoleId },
    responseType: "blob",
  });

export const insertDraftEmail = (docIds, templateId, userId) => {
  return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.INSERT_DRAFT_EMAIL, {
    params: {
      docIds,
      templateId,
      userId
    }
  });
};

export const getDocumentsByWebStatus = (categories, documentname, fromdate, todate, uploaddate, webstatus, contactids, accountids) => {
    return apiClient.get(ADMIN_DOCUMENTS_ENDPOINTS.GET_DOCUMENT_BY_WEBSTATUS,{
        params:{
            fromDate:fromdate,
            toDate:todate,
            UploadDate:uploaddate,
            documentTypeIds:categories,
            WebStatusID:webstatus,
            documentName:documentname,
            ContactIds:contactids,
            AccountIds:accountids
        }
    })
}

export const getUserCustomSettings = (userid, page, setting) => {
    return apiClient.get(`${ADMIN_DOCUMENTS_ENDPOINTS.GET_USER_CUSTOM_SETTINGS}/${userid},${page},${setting}`)
}

export const updateCustomSettings = (payload) => {
    return apiClient.post(ADMIN_DOCUMENTS_ENDPOINTS.UPDATE_CUSTOM_SETTINGS, payload)
}